// extracted by mini-css-extract-plugin
module.exports = {"root":"LineClampCollapse_root__eDMQQ","header":"LineClampCollapse_header__SiP0o","icon":"LineClampCollapse_icon__qrWfO","open":"LineClampCollapse_open__pTr_S"};